import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=328f8dae&scoped=true&"
import script from "./BaseTabs.vue?vue&type=script&lang=js&"
export * from "./BaseTabs.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BaseTabs.vue?vue&type=style&index=1&id=328f8dae&scoped=true&lang=css&"
import style2 from "./BaseTabs.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f8dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328f8dae')) {
      api.createRecord('328f8dae', component.options)
    } else {
      api.reload('328f8dae', component.options)
    }
    module.hot.accept("./BaseTabs.vue?vue&type=template&id=328f8dae&scoped=true&", function () {
      api.rerender('328f8dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/BaseTabs.vue"
export default component.exports